import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet-async";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import DeplacementsPage from "@/pages/DeplacementsPage";
import GreetMeetPage from "@/pages/GreetMeetPage";
import SecuritePage from "@/pages/SecuritePage";
import TransportLuxePage from "@/pages/TransportLuxePage";
import TransportSEOPage from "@/pages/TransportSEOPage";
import ContactPage from "@/pages/ContactPage";
import FounderPage from "@/pages/FounderPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import { RangeRoverPage, ClasseGPage, MaybachPage } from "@/pages/VehiclePages";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";
import { TransfertCDGPage, TransfertOrlyPage, TransfertDisneylandPage, TransfertVersaillesPage } from "@/pages/DestinationPages";
import { VisiteReimsPage, VisiteGivernyPage, VisiteLoirePage, VisiteNormandiePage, VisiteBrugesPage, VisiteVersaillesPage, VisiteFontainebleauPage } from "@/pages/VisitePages";
import VisitesIndexPage from "@/pages/VisitesIndexPage";
import MariagePage from "@/pages/MariagePage";
import ExperiencesPage from "@/pages/ExperiencesPage";
import ParisSurMesurePage from "@/pages/ParisSurMesurePage";
import FashionWeekPage from "@/pages/FashionWeekPage";
import ShoppingLuxePage from "@/pages/ShoppingLuxePage";

// Altura Connect
import { ConnectAuthProvider } from "@/pages/connect/ConnectAuthContext";
import ConnectLoginPage from "@/pages/connect/ConnectLoginPage";
import ConnectApplyPage from "@/pages/connect/ConnectApplyPage";
import AdminDashboard from "@/pages/connect/AdminDashboard";
import PartnerDashboard from "@/pages/connect/PartnerDashboard";
import ConnectPaymentSuccess from "@/pages/connect/ConnectPaymentSuccess";
import ConnectForgotPassword from "@/pages/connect/ConnectForgotPassword";
import ConnectResetPassword from "@/pages/connect/ConnectResetPassword";
import DraftEditPage from "@/pages/DraftEditPage";

// Property Services
import PropertyServicesPage from "@/pages/property/PropertyServicesPage";
import AutoCleaningPage from "@/pages/property/AutoCleaningPage";
import FurnitureCleaningPage from "@/pages/property/FurnitureCleaningPage";
import ApartmentCleaningPage from "@/pages/property/ApartmentCleaningPage";
import CommercialCleaningPage from "@/pages/property/CommercialCleaningPage";
import PropertySEOPage from "@/pages/property/PropertySEOPage";
import ReviewPage from "@/pages/property/ReviewPage";
import RealisationsPage from "@/pages/property/RealisationsPage";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const VisitesRedirect = () => {
  const slug = window.location.pathname.split("/visites/")[1];
  return <Navigate to={`/destinations/${slug}`} replace />;
};

const PublicLayout = () => (
  <>
    <Navigation />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/deplacements" element={<DeplacementsPage />} />
      <Route path="/services/greet-meet" element={<GreetMeetPage />} />
      <Route path="/services/securite" element={<SecuritePage />} />
      <Route path="/services/transport-luxe" element={<TransportLuxePage />} />
      <Route path="/services/chauffeur-prive-versailles" element={<TransportSEOPage />} />
      <Route path="/services/chauffeur-prive-poissy" element={<TransportSEOPage />} />
      <Route path="/services/chauffeur-prive-saint-germain-en-laye" element={<TransportSEOPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/fondateur" element={<FounderPage />} />
      <Route path="/reservation/success" element={<PaymentSuccessPage />} />
      <Route path="/reservation/brouillon/:draftId" element={<DraftEditPage />} />
      <Route path="/vehicules/range-rover" element={<RangeRoverPage />} />
      <Route path="/vehicules/classe-g" element={<ClasseGPage />} />
      <Route path="/vehicules/maybach" element={<MaybachPage />} />
      <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
      <Route path="/transfert-aeroport-cdg" element={<TransfertCDGPage />} />
      <Route path="/transfert-aeroport-orly" element={<TransfertOrlyPage />} />
      <Route path="/chauffeur-prive-disneyland" element={<TransfertDisneylandPage />} />
      <Route path="/chauffeur-prive-versailles" element={<TransfertVersaillesPage />} />
      <Route path="/services/mariage" element={<MariagePage />} />
      <Route path="/experiences" element={<ExperiencesPage />} />
      <Route path="/experiences/mariage" element={<MariagePage />} />
      <Route path="/experiences/paris-sur-mesure" element={<ParisSurMesurePage />} />
      <Route path="/experiences/fashion-week" element={<FashionWeekPage />} />
      <Route path="/experiences/shopping-luxe" element={<ShoppingLuxePage />} />
      <Route path="/destinations" element={<VisitesIndexPage />} />
      <Route path="/destinations/reims-champagne" element={<VisiteReimsPage />} />
      <Route path="/destinations/giverny-monet" element={<VisiteGivernyPage />} />
      <Route path="/destinations/chateaux-loire" element={<VisiteLoirePage />} />
      <Route path="/destinations/plages-debarquement-normandie" element={<VisiteNormandiePage />} />
      <Route path="/destinations/bruges-belgique" element={<VisiteBrugesPage />} />
      <Route path="/destinations/chateau-versailles" element={<VisiteVersaillesPage />} />
      <Route path="/destinations/fontainebleau" element={<VisiteFontainebleauPage />} />
      <Route path="/visites" element={<Navigate to="/destinations" replace />} />
      <Route path="/visites/:slug" element={<VisitesRedirect />} />
      {/* Property Services */}
      <Route path="/property-services" element={<PropertyServicesPage />} />
      <Route path="/property-services/automobile" element={<AutoCleaningPage />} />
      <Route path="/property-services/mobilier" element={<FurnitureCleaningPage />} />
      <Route path="/property-services/appartement" element={<ApartmentCleaningPage />} />
      <Route path="/property-services/commercial" element={<CommercialCleaningPage />} />
      <Route path="/property-services/avis/:requestId/:token" element={<ReviewPage />} />
      <Route path="/property-services/realisations" element={<RealisationsPage />} />
      <Route path="/property-services/:slug" element={<PropertySEOPage />} />
    </Routes>
    <Footer />
  </>
);

function App() {
  const schemaLD = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "ALTURA Conciergerie",
    "description": "Conciergerie de transport privé de luxe à Paris. Chauffeurs privés, transferts aéroports CDG et Orly, sécurité rapprochée, transport de biens précieux.",
    "url": "https://alturaconciergerie.com",
    "telephone": "+33681969342",
    "email": "contact@alturaconciergerie.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Paris",
      "addressRegion": "Île-de-France",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.8566,
      "longitude": 2.3522
    },
    "areaServed": [
      { "@type": "City", "name": "Paris" },
      { "@type": "AdministrativeArea", "name": "Île-de-France" }
    ],
    "priceRange": "€€€",
    "serviceType": ["Chauffeur privé", "Transfert aéroport", "VTC luxe", "Sécurité rapprochée", "Transport de luxe", "Meet & Greet aéroport"],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    "image": "https://customer-assets.emergentagent.com/job_parisgo/artifacts/09akaoz4_4DC035C4-C368-4BCB-A49F-408B01512975.jpeg",
    "sameAs": []
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Chauffeur privé de luxe",
    "provider": {
      "@type": "LocalBusiness",
      "name": "ALTURA Conciergerie"
    },
    "areaServed": { "@type": "City", "name": "Paris" },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Véhicules avec chauffeur",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mercedes Classe E — Chauffeur privé Paris", "description": "Berline de prestige, 3 passagers max. À partir de 70€." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mercedes Classe S — Chauffeur privé Paris", "description": "Berline haut de gamme, 3 passagers max. À partir de 90€." } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mercedes Classe V — Chauffeur privé Paris", "description": "Van de luxe, 7 passagers max. À partir de 80€." } }
      ]
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      { "@type": "Question", "name": "Comment réserver un chauffeur privé ALTURA à Paris ?", "acceptedAnswer": { "@type": "Answer", "text": "Vous pouvez réserver directement en ligne sur notre site en choisissant votre véhicule, votre date et votre trajet. Le paiement se fait en ligne par carte bancaire ou à bord auprès du chauffeur." } },
      { "@type": "Question", "name": "Quels véhicules sont disponibles chez ALTURA ?", "acceptedAnswer": { "@type": "Answer", "text": "ALTURA propose des Mercedes Classe E (3 passagers), Classe S (3 passagers), Classe V (7 passagers), ainsi que Range Rover Autobiography, Mercedes Classe G et Mercedes-Maybach Classe S sur devis." } },
      { "@type": "Question", "name": "Proposez-vous des transferts vers les aéroports de Paris ?", "acceptedAnswer": { "@type": "Answer", "text": "Oui, nous assurons les transferts vers et depuis tous les aéroports parisiens : Charles de Gaulle (CDG), Orly et Le Bourget, avec des forfaits dédiés." } },
      { "@type": "Question", "name": "Quel est le tarif d'un chauffeur privé à Paris ?", "acceptedAnswer": { "@type": "Answer", "text": "Les tarifs débutent à partir de 70€ pour une Mercedes Classe E, 80€ pour une Classe V et 90€ pour une Classe S. Le prix est calculé selon la distance ou le forfait applicable (aéroport, gare, Disneyland, Versailles)." } },
      { "@type": "Question", "name": "ALTURA est-il disponible 24h/24 ?", "acceptedAnswer": { "@type": "Answer", "text": "Oui, ALTURA est disponible 24 heures sur 24, 7 jours sur 7, y compris les jours fériés. Vous pouvez réserver à tout moment via notre site ou par WhatsApp." } }
    ]
  };

  return (
    <HelmetProvider>
    <div className="App min-h-screen bg-[#050505]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schemaLD)}</script>
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <BrowserRouter>
        <Routes>
          {/* Altura Connect — Private portal (no site nav/footer) */}
          <Route path="/connect" element={<ConnectAuthProvider><ConnectLoginPage /></ConnectAuthProvider>} />
          <Route path="/connect/apply" element={<ConnectApplyPage />} />
          <Route path="/connect/admin" element={<ConnectAuthProvider><AdminDashboard /></ConnectAuthProvider>} />
          <Route path="/connect/dashboard" element={<ConnectAuthProvider><PartnerDashboard /></ConnectAuthProvider>} />
          <Route path="/connect/payment/success" element={<ConnectPaymentSuccess />} />
          <Route path="/connect/payment/cancel" element={<ConnectPaymentSuccess />} />
          <Route path="/connect/forgot-password" element={<ConnectForgotPassword />} />
          <Route path="/connect/reset-password" element={<ConnectResetPassword />} />
          {/* Public site with Navigation + Footer */}
          <Route path="*" element={<PublicLayout />} />
        </Routes>
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
